<template>
    <SensorAlarmPayload
        v-if="issue.payload.type === issuePayloadType.SENSOR_ALARM"
        :payload="issue.payload"
        :last-measurement="issue.sensorsLastMeasurement"
    />
    <AutomaticInformPayload
        v-else-if="isAutomaticOrInformPayloadWithBreadcrumb"
        :payload="issue.payload"
    />
    <div v-else></div>
</template>

<script>
    import SensorAlarmPayload from '@/views/Issues/Payloads/SensorAlarm.vue';
    import AutomaticInformPayload from '@/views/Issues/Payloads/AutomaticInformPayload.vue';
    import { ISSUE_PAYLOAD_TYPE } from '@/constants';

    export default {
        components: {
            SensorAlarmPayload,
            AutomaticInformPayload,
        },
        props: {
            issue: {
                type: Object,
                required: true,
            },
        },
        computed: {
            issuePayloadType() {
                return ISSUE_PAYLOAD_TYPE;
            },
            isAutomaticOrInformPayloadWithBreadcrumb() {
                return [ISSUE_PAYLOAD_TYPE.IN_FORM, ISSUE_PAYLOAD_TYPE.AUTOMATIC].includes(this.issue.payload.type) && this.issue.payload.breadcrumb;
            },
        },
    };
</script>
